"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasEvents = hasEvents;
exports.TimelineEventsPropType = exports.getViewType = void 0;

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _reactImmutableProptypes = require("react-immutable-proptypes");

var _immutable = require("immutable");

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CONVERSATIONS = 'CONVERSATIONS';

var isLoggedEmail = function isLoggedEmail(type, timelineItem) {
  return type === _EngagementTypes.EMAIL && !(timelineItem.hasIn(['eventData', 'metadata', 'trackerKey']) || timelineItem.hasIn(['eventData', 'metadata', 'threadId']) || timelineItem.getIn(['eventData', 'engagement', 'source'], '') === CONVERSATIONS);
};

var isLoggedMeeting = function isLoggedMeeting(type, timelineItem) {
  return type === _EngagementTypes.MEETING && !timelineItem.hasIn(['eventData', 'metadata', 'title']);
};

var getViewType = (0, _memoize.default)(function (EventTypeMap, timelineItem) {
  var etype = timelineItem.get('etype');

  if (!etype) {
    return null;
  }

  if (etype === 'eventEngagement') {
    var type = timelineItem.getIn(['eventData', 'engagement', 'type']);

    if (isLoggedEmail(type, timelineItem)) {
      type = 'LOGGED_EMAIL';
    }

    if (isLoggedMeeting(type, timelineItem)) {
      type = 'LOGGED_MEETING';
    }

    return EventTypeMap.getIn(['eventEngagement', type]);
  }

  return EventTypeMap.get(etype);
});
exports.getViewType = getViewType;

function hasEvents(events, timelineStatus, hasPinnedEngagement) {
  return !!(events && events.size > 0 && events.findIndex(function (el) {
    return el.get('etype');
  }) > 0) || timelineStatus.get('hasMore') || timelineStatus.get('isFetching') || !!hasPinnedEngagement;
}

var TimelineEventsPropType = _propTypes.default.oneOfType([_propTypes.default.instanceOf(_immutable.List), (0, _reactImmutableProptypes.listOf)(_propTypes.default.oneOfType([(0, _reactImmutableProptypes.mapContains)({
  label: _propTypes.default.string.isRequired,
  text: _propTypes.default.string,
  etype: _propTypes.default.string,
  eventData: _propTypes.default.instanceOf(_immutable.Map),
  id: _propTypes.default.string.isRequired,
  orderingId: _propTypes.default.string.isRequired,
  timestamp: _propTypes.default.number.isRequired
}), (0, _reactImmutableProptypes.mapContains)({
  label: _propTypes.default.string.isRequired,
  count: _propTypes.default.number.isRequired,
  text: _propTypes.default.string
}), (0, _reactImmutableProptypes.mapContains)({
  isFuture: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired
})]))]);

exports.TimelineEventsPropType = TimelineEventsPropType;